import React from 'react';
import Hero from '../components/sections/Hero';
import Availability from '../components/common/Availability';

const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <Availability />
    </>
  );
};

export default Home;
